module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="project-wrapper">\n    <div class="actions-panel">\n        ';
 if (cannotDelete) { ;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete Projects."></span>\n        ';
} else {;
__p += '\n            <span class="delete pull-right" data-content="Delete Project. No Experiences, Images or Slots will be deleted."></span>\n        ';
};
__p += '\n    </div>\n    <a class="project-thumb" href="#project/' +
__e( id ) +
'">\n        <div class="project-title" title="' +
__e( projectName ) +
'">' +
__e( projectName ) +
'</div>\n        <div class="experiences-count">' +
__e( experienceCountLabel ) +
'</div>\n        <div class="experiences-thumbs">\n            <div class="experience-thumb"></div>\n        </div>\n    </a>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/projects/ProjectItemView.tpl
// module id = 3103
// module chunks = 0